import { Input, InputProps } from 'antd';

export const PriceInput = (props: InputProps) => {
  return <Input addonBefore={'R$'} style={{ width: '100%' }} {...props} />;
};
